import qs from 'qs'

import request, { Res, TaiRes } from '@/utils/request'

// 校验房间内用户
export const verityRoomUser = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/channel/user`, qs.stringify(data))
}

// 上传设备检测结果
export const putDevicesInfo = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/device/putDevices`, qs.stringify(data))
}

// 获取服务器时间
export const getTimeStamp = () => {
  return request.get<Res, Res>(`/pc_api/api/pc/getTimeStamp`)
}

// 进入临时房间
export const enterRoom = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/inSpareRoom`, qs.stringify(data))
}

// 离开房间
export const leaveRoom = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/leave_room`, qs.stringify(data))
}

// 用户详情
export const getUserDetail = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/roomUserDetail`, qs.stringify(data))
}

// 课件休息结束
export const recordStopInfo = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/breakInClass/recordStopInfo`, data)
}

// 学员课件休息开关
export const getStuSwitchInfo = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/breakInClass/getStuSwitchInfo`, data)
}

// 课件一级 - 主题
export const fetchCouseLevel0 = (data: any) => {
  return request.post<Res, Res>(`/xbk_api/api/in/room/subjectList`, qs.stringify(data))
}

// 课件二级 未使用
export const fetchCouseLevel1 = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/series2`, qs.stringify(data))
}

// 课件三级
export const fetchCouseLevel2 = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/course`, qs.stringify(data))
}

// 获取课程课件 未使用
export const getCourseWare = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/getCourseWare`, qs.stringify(data))
}

// 上传图片课件 未使用
export const putTempImg = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/putTempImg`, qs.stringify(data))
}

// 获取课中点评数据
export const getRemarkList = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/teacher/v195/getevention', qs.stringify(data))
}

// 保存课中点评数据
export const saveRemarkList = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/teacher/v195/editeventionInRoom', qs.stringify(data))
}

export const replaceCourse = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/replaceCourse', qs.stringify(data))
}

// IP用于日志上报 TODO
export const getPublishIp = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/third/ip_location', qs.stringify(data))
}

// 根据服务端新增接口去做自动地区判断，是否切换代理服务 TODO
export const getSwitchLine = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/third/change_line_middle_east', qs.stringify(data))
}

// 更详细的上传设备检测结果
export const putDevicesInfos = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/putDeviceLog', qs.stringify(data))
}

// 课中求助类型 TODO
export const getHelpInfo = ({ type }: { type: string }) => {
  return request.get<Res, Res>(`/xbk_api/api/courseHelp/getInfo?type=${type}`)
}

export const getCoursesInfo = () => {
  return request.get<Res, Res>('/xbk_api/api/courseProblem/listOption')
}

// 课中求助 TODO
export const putHelpInfo = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/courseHelp/putInfo', qs.stringify(data))
}

export const putCoursesInfo = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/courseProblem/feedback', data)
}

// 课件四级
export const fetchCouseLevel3 = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/courseInfoV2', qs.stringify(data))
}

// 获取当前线路
export const getRoomType = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/h5/getRoomType', qs.stringify(data))
}

// 修改房间线路 TODO
export const changeLine = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/changeRoomRoute', qs.stringify(data))
}

// 设置视频分辨帧率码率等信息
export const roomConfig = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/room/roomConfig', qs.stringify(data))
}

// 教室内用户信息接口
export const getRoomUserInfo = (data: any) => {
  return request.get<Res, Res>(`/xbk_api/api/getRoomUserInfo?userId=${data.userId}&lessonTimeId=${data.lessonTimeId}`)
}

// 课件搜索
export const searchText = (data: any) => {
  return request.get<Res, Res>(`/xbk_api/api/in/class/search?courseTitle=${data.courseTitle}&pageNum=${data.pageNum || 1}&pageSize=${data.pageSize || 1000}&userId=${data.userId}`)
}

// 新课件二级 - 系列
export const fetchCouseLevelNew1 = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/in/room/subjectSeriesList', qs.stringify(data))
}

// 新课件三级 - 单元
export const fetchCouseLevelNew2 = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/in/room/subjectSeriesUnitList', qs.stringify(data))
}

// 无知识点层级时的新课件四级 - 课件
export const fetchCouseLevelNew03 = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/in/room/subjectSeriesUnitTopicAndCourseList', qs.stringify(data))
}

// 有知识点层级时的新课件四级 - 知识点
export const fetchCouseLevelNew3 = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/in/room/subjectSeriesUnitTopic', qs.stringify(data))
}

// 新课件五级 - 有知识点的课件
export const fetchCouseLevelNew4 = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/in/room/subjectSeriesUnitTopicCourse', qs.stringify(data))
}

// 课件定位信息,教室内课件搜索默认展示课件所属的层级
export const courseLocation = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/in/room/courseLocation', qs.stringify(data))
}

// 【灰度课件埋点接口】完课后调用
export const buriedPoint = (data: { courseId: number; lessonTimeId: number; roomId: string; userId: number }) => {
  return request.post<Res, Res>('/xbk_api/api/in/class/course/change/update', qs.stringify(data))
}

// 灰度课件上传图片埋点接口
export const changePicUpdate = (data: { lessonTimeId: number; roomId: string; userId: string; uploadPicCount: number; uploadType: number }) => {
  return request.post<Res, Res>('/xbk_api/api/in/class/course/change/picUpdate', qs.stringify(data))
}

// 开始录制
export const startRecord = (params: any, data: any) => {
  return request.post<Res, Res>(`/recorder_api/recorder/v1/start?${qs.stringify(params)}`, qs.stringify(data), {
    headers: {
      identity: 0,
      userid: localStorage.userid
    }
  })
}

// 结束录制
export const stopRecord = (params: any, data: any) => {
  return request.post<Res, Res>(`/recorder_api/recorder/v1/stop?${qs.stringify(params)}`, qs.stringify(data), {
    headers: {
      identity: 0,
      userid: localStorage.userid
    }
  })
}

// 录制分辨率
export const setresolution = (data: any) => {
  return request.post<Res, Res>('/recorder_api/recorder/v1/setresolution', qs.stringify(data))
}

export interface UploadUserInfo {
  lessonTimeId: number
  userId: number
  /**
   * 用户类型 1 老师 2 学生
   */
  userType: 1 | 2
  // 上课时间
  classTime: number
  // 1 老师学生都在教室 2 老师在教室 课程类型？
  classType: 1 | 2
  /**
   * APP 学生 PC 老师
   */
  deviceType: 'PC' | 'APP'
  // 10位
  time: number
}

// 上报房间人员信息 - 消课用
export const uploadUserInfo = (data: any) => {
  return request.post<Res, Res>('/es_api/api/putClassData', qs.stringify(data))
}

// 上报房间信息 - 教室上下课统计
export const uploadTurnverInfo = (data: any) => {
  return request.post<Res, Res>('/es_api/api/device/classreport', qs.stringify(data))
}

// 鉴黄频率规则
export const getTeacherRule = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/teacher/ai/rule', data)
}

// 鉴黄上报
export const getTeacherReport = (data: any) => {
  return request.post<TaiRes, TaiRes>('/tai_api/check/ai_supervise', data)
}

// 高光时刻上报
export const notify = (data: any) => {
  return request.post<TaiRes, TaiRes>('/xbk_api/api/callback/highlight/notify', data)
}

// 上传图片鉴黄
export const checkPicList = (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/app/checkImage', data)
}

// 家长会信息
export const querySurvey = (timesId: number) => {
  return request.get<Res, Res>(`/xbk_api/api/app/querySurvey?timesId=${timesId}`)
}

// 家长会确认出席保存状态
export const parentsAttend = (timesId: number, status: number) => {
  return request.post<Res, Res>(`/xbk_api/api/app/parentsAttend?timesId=${timesId}&status=${status}`)
}

// 家长会确认出席获取状态
export const getParentsAttendStatus = (timesId: number) => {
  return request.post<Res, Res>(`/xbk_api/api/app/getParentsAttendStatus?timesId=${timesId}`)
}

// 查询学员作品
export const getWorks = (data: any) => {
  return request.post<Res, Res>(`/xbk_api/api/works/m/listOldAndNew`, qs.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取即构 token
export const getZegoToken = async (data: any) => {
  return request.post<Res, Res>('/pc_api/api/pc/authorization/getZeGoInRoomToken', data)
}

// 绘画五步法提交填写内容
export const recordFiveStepPaint = async (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/teaRoom/recordFiveStepPaint', data)
}

// 获取教师端课中绘画五步法完成情况的填写
export const getFiveStepPaintInfo = async (data: any) => {
  return request.post<Res, Res>('/xbk_api/api/teaRoom/getFiveStepPaintInfo', data)
}

// 保存到作品
export const uploadWorkVideo = async (data: any) => {
  // data 是json，需要传form data
  const formData = new FormData()
  for (const key in data) {
    formData.append(key, data[key])
  }
  return request.post<Res, Res>('/xbk_api/api/createtogether/uploadWorkVideo', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      userid: localStorage.userid
    }
  })
}
